import { Schema } from "effect";

/** The cancellation start's success body. It lives in its own module so that
 * frozen fixtures of the canary modules keep building. */
export const TunnelCanaryCompleted = /* @__PURE__ */ (() => Schema.Struct({ completed: Schema.Literal(true) }))();
